import { reactive } from 'vue';

export type SNACKSTATUS =
  | 'idle'
  | 'loading'
  | 'success:create'
  | 'success:delete'
  | 'success:update'
  | 'error';

// 🔄 Fully reactive plain objects instead of Map
const updateStatusMap = reactive<Record<string, SNACKSTATUS>>({});
const updateErrorMap = reactive<Record<string, string | undefined>>({});

export function useUpdateStatusMap() {
  const setSuccessStatus = (key: string, status: SNACKSTATUS): void => {
    updateStatusMap[key] = status;
    setError(key, undefined);
    clearStatusAfterDelay(key);
  };

  const setErrorStatus = (key: string, msg: string | undefined): void => {
    updateStatusMap[key] = 'error';
    setError(key, msg);
    clearStatusAfterDelay(key);
  };

  const getStatus = (key: string): SNACKSTATUS | undefined => {
    return updateStatusMap[key];
  };

  const clearStatus = (key: string): void => {
    delete updateStatusMap[key];
    delete updateErrorMap[key];
  };

  const clearStatusAfterDelay = (key: string, delay = 3000): void => {
    setTimeout(() => clearStatus(key), delay);
  };

  const setError = (key: string, msg: string | undefined): void => {
    updateErrorMap[key] = msg;
  };

  const getError = (key: string): string | undefined => {
    return updateErrorMap[key];
  };

  return {
    setSuccessStatus,
    setErrorStatus,
    getStatus,
    getError,
    clearStatus,
  };
}
